import React from 'react'
import Login from './pages/commom/Login'
import Main from './pages/commom/Main'
import Cookie from 'js-cookie'
export default class App extends React.Component {
    render() {
        return Cookie.get('identityType') && Cookie.get('token') ? <Main {...this.props} /> : <Login {...this.props} />
    }
}
